module.exports = __webpack_public_path__ + "media/applicants/device_signup_7-a0bf19b7.jpg";